import React from 'react'
import { Link } from 'react-router-dom'
import User from '../store/user.store'
import PropTypes from 'prop-types'
import { appFeatureEnabled } from '../service/appFeatures.service'

const Submenu = ({ currentPage, item, visible, linkClick }) => {
  if (!visible) return null
  return (
    <div className='nav-link-wrapper sub-nav'>
      <ul className='navbar-nav mr-auto'>
        { item.submenu.map(i => {
          if (i.path === '/letters' && !(appFeatureEnabled('lettersEnabled', User.contracts) || appFeatureEnabled('lettersEnabledForCondo', User.contracts))) return
          if (i.feature && !appFeatureEnabled(i.feature, User.contracts)) return
          var iconClass = ''
          if (i.path === '/loyalty-program') iconClass = ' loyalty'
          if (localStorage.getItem('locale') === 'de') iconClass += ' de'

          i.active = currentPage === i.path || currentPage.includes(i.path)
          return (
            <li
              key={i.path}
              className={`nav-item sub-nav ${i.active && 'active'} ${iconClass && iconClass}`}
            >
              <Link to={i.path} className='nav-link' onClick={(e) => linkClick(i.path)}
                data-bs-toggle='collapse'
                data-bs-target='#navbarSupportedContent'
                aria-controls='navbarSupportedContent'>
                <span>
                  {i.svg}
                  {i.name}
                </span>
              </Link>
            </li>
          )
        })}
      </ul>
    </div>
  )
}
Submenu.propTypes = {
  currentPage: PropTypes.string.isRequired,
  linkClick: PropTypes.func.isRequired,
  item: PropTypes.object.isRequired,
  visible: PropTypes.bool.isRequired,
}
export default Submenu
